import { css } from "vite-css-in-js"
import type { DialogHTMLAttributes } from "vue"
import { Modal as Dialog, defineComponent, inferProps, propsWithDefaults, renderSlot, type ReactiveComponent } from "vue-utils"

interface Props {
	zIndex?: number
	onCancel?: (e: Event) => void
}

const dialogStyles = css`
	display:flex;
	flex-direction: column;
`

const Modal: ReactiveComponent<Props, DialogHTMLAttributes> = (initialProps, { attrs, slots }) => {
	const props = propsWithDefaults(initialProps, {
		zIndex: 3,
		onCancel: (e) => e.preventDefault(),
	})

	return () => (
		<Dialog class={dialogStyles} zIndex={props.zIndex} onCancel={props.onCancel} {...attrs}>
			{renderSlot(slots)}
		</Dialog>
	)
}

export default defineComponent(Modal, inferProps<Props>())
